<!-- @migration-task Error while migrating Svelte code: $$props is used together with named props in a way that cannot be automatically migrated. -->
<script lang="ts">
  type Props = {
    style?: string;
    width?: number;
    height?: number;
  };

    let { style = "", width = 24, height = 24 }: Props = $props();

</script>
<svg xmlns="http://www.w3.org/2000/svg" style={style} width={width} height={height} viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 9h4V5M3 3l6 6m-4 6h4v4m-6 2l6-6m10-6h-4V5m0 4l6-6m-2 12h-4v4m0-4l6 6"/>
</svg>
